import React, {Component} from 'react';
import {Col, ListGroup, ListGroupItem, Row} from "react-bootstrap";


const generateSearchQueryStr = (element) => {

    let searchParams = {};

    if (element.type && element.type === 'design') {
        searchParams['category'] = element._id;
    }

    searchParams['query'] = element.name;


    let queryStr = [];
    for (let key in searchParams) {
        if (searchParams.hasOwnProperty(key)) {
            queryStr.push(key+"="+encodeURIComponent(searchParams[key]))
        }
    }
    return queryStr.join("&");
};

const ResultCard = ({element, id, redirectPage}) => {

    let queryStr = generateSearchQueryStr(element);

    if (element.type && element.type === 'design') {
        return (
            <ListGroupItem
                key={"dashboard-search-item-"+id}
                onMouseDown={() => redirectPage("/designmaker/start/search?"+queryStr)}
                className="resultCard"
            >
                <span>{element.name} ({element.dimensions.width} X {element.dimensions.height} {element.dimensions.unit})</span>
            </ListGroupItem>
        );
    } else {
        return (
            <ListGroupItem
                key={"dashboard-search-item-"+id}
                onMouseDown={() => redirectPage("/designmaker/start/search?"+queryStr)}
                className="resultCard"
            >
                <span>{element.name} templates</span>
            </ListGroupItem>
        );
    }
};

const SearchResultsContainer = ({data, redirectPage, display}) => {
    if (data && data.length) {
        return (
            <ListGroup style={{maxHeight: 300, overflowY: 'auto', zIndex: 10, marginBottom: 0, display : 'none'}} className={display?"showSearchContainer":null}>
                {data.map((element, id) => <ResultCard element={element} id={id} key={"dashboard-search-result-container-"+id} redirectPage={redirectPage}/>)}
            </ListGroup>
        );
    }
    return null;
};

class SearchContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            searchText: "",
            displaySearchCard: false,
            searchResults: []
        }
    };

    handleSearchSubmit = () => {

    };

    handleSearchOnChange = (e) => {
        this.setState({
            searchText: e.target.value
        }, this.fetchSearchResults)
    };

    fetchSearchResults = () => {
        let results = this.props.categories.filter(x => x.name.toLowerCase().search(this.state.searchText.toLowerCase()) >= 0);
        this.setState({
            searchResults: results.concat([{"name": this.state.searchText}])
        })
    };

    handleKeyPress = (event) => {
        if(event.key === 'Enter' && this.state.searchText.length){
            let queryStr = generateSearchQueryStr({name : this.state.searchText});
            this.props.redirectPage("/designmaker/start/search?"+queryStr);
        }
    };

    render() {
        return (
            <Row style={{
                "height": "299px",
                "backgroundColor": "white",
                "borderRadius": "5px",
                backgroundRepeat: "no-repeat",
                backgroundImage: "url("+(global.config.static_file_server_path + "uploads/icons/dashboard_bg.jpg")+")",
                backgroundSize: "cover"
            }} className="center_heading">
                <Col xs={3}/>
                <Col xs={6}>
                    <Row style={{'textAlign': 'center'}}>
                        <span style={{fontFamily: 'Montserrat', fontWeight: '800', fontSize: 42}}>WHAT WOULD YOU LIKE TO DESIGN?</span>
                    </Row>
                    <br/>
                    <Row>
                        <div
                            style={{
                                background: 'white',
                                width: '100%',
                                position: 'absolute',
                                borderRadius: 4,
                                border: '1px solid #ccc',
                                zIndex: 10
                            }}
                            onBlur={() => this.setState({'displaySearchCard': false})}
                        >
                            <input
                                style={{
                                    fontSize: 14,
                                    fontFamily: 'Montserrat',
                                    height: 42,
                                    border: 'none',
                                    borderRadius: 4,
                                    width: '100%',
                                    padding: '10px 15px'
                                }}
                                placeholder='Try "Business Card"'
                                value={this.state.searchText} type="text"
                                onChange={(e) => this.handleSearchOnChange(e)}
                                onFocus={() => this.setState({'displaySearchCard': true})}
                                onKeyDown={(e) => this.handleKeyPress(e)}
                            />
                            {this.state.displaySearchCard ?
                                (<span
                                    onClick={() => this.setState({searchText: ''})}
                                    style={{
                                        cursor: 'pointer',
                                        position: 'absolute',
                                        right: 12,
                                        top: 9,
                                        fontSize: 22,
                                        zIndex: 100,
                                        color: '#C8CDD4'
                                    }} className="fas fa-times fa-2x fas-light"/>)
                                : (<span onClick={this.handleSearchSubmit} style={{
                                    position: 'absolute',
                                    cursor: 'pointer',
                                    right: 12,
                                    top: 9,
                                    fontSize: 22,
                                    zIndex: 100,
                                    color: '#C8CDD4'
                                }} className="fas fa-search fa-2x fas-light"/>)
                            }
                            {(this.state.searchText === "") ?
                                    (<SearchResultsContainer display={this.state.displaySearchCard} data={this.props.categories} redirectPage={this.props.redirectPage}/>) :
                                    (<SearchResultsContainer display={this.state.displaySearchCard} data={this.state.searchResults} redirectPage={this.props.redirectPage}/>)}
                        </div>
                    </Row>

                </Col>
                <Col xs={3}/>
            </Row>
        );
    }

}

export default SearchContainer;